import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import FilterWrapperBasic, {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {getInitialValue} from '../utils.js'

const filterName = 'makes'
const filterNotSure = 'notSure'

export const MakesFilter = ({options, onChange, value}) => {
  const {i18n} = useContext(Context)
  const [selectedMakesOption, setSelectedMakesOption] = useState(getInitialValue({options, value}))

  const _handleOnChange = item => {
    if (item.name === filterNotSure) {
      setSelectedMakesOption([])
      return onChange([])
    }
    const {value: newMakesIds} = item
    setSelectedMakesOption(newMakesIds)
    onChange(newMakesIds)
  }
  const filters = [
    {
      name: filterNotSure,
      options: [{id: 'notSure', label: 'No lo tengo claro'}],
      type: filterBasicTypes.SINGLE_SELECTION_OUTLINED
    },
    {
      name: filterName,
      options,
      type: filterBasicTypes.MULTI_SELECTION_OUTLINED
    }
  ]

  return (
    <FilterWrapperBasic
      filters={filters}
      group={`${filterName}Group`}
      legend={i18n.t('COMMON.PLURALS.MAKE', 2)}
      onChange={_handleOnChange}
      value={{[filterName]: selectedMakesOption, [filterNotSure]: selectedMakesOption.length === 0 ? ['notSure'] : []}}
      wrapper={filterWrapperBasicTypes.NONE}
    />
  )
}

MakesFilter.propTypes = {
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}
